import { CheckCircleIcon, ClockIcon, MinusCircleIcon } from '@heroicons/react/24/outline';

interface ActivityStepProps {
  number: string;
  title: string;
  responsible: string;
  description: string;
  status: 'not-started' | 'ongoing' | 'complete';
  lastUpdate?: {
    role: string;
    timestamp: string;
  };
  isSubStep?: boolean;
}

export default function ActivityStep({
  number,
  title,
  responsible,
  description,
  status,
  lastUpdate,
  isSubStep = false,
}: ActivityStepProps) {
  const getStatusIcon = () => {
    switch (status) {
      case 'complete':
        return <CheckCircleIcon className="h-5 w-5 text-green-500" />;
      case 'ongoing':
        return <ClockIcon className="h-5 w-5 text-yellow-500" />;
      default:
        return <MinusCircleIcon className="h-5 w-5 text-gray-400" />;
    }
  };

  const getStatusText = () => {
    switch (status) {
      case 'complete':
        return 'Complete';
      case 'ongoing':
        return 'Ongoing';
      default:
        return 'Not Started';
    }
  };

  return (
    <div className={`border rounded-lg p-4 ${isSubStep ? 'ml-8' : ''}`}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-2">
            <span className="text-sm font-medium text-gray-500">{number}</span>
            <h4 className="font-medium text-gray-900">{title}</h4>
          </div>
          <p className="mt-1 text-sm text-gray-600">
            <span className="font-medium">Responsible:</span> {responsible}
          </p>
          <p className="mt-1 text-sm text-gray-600">{description}</p>
        </div>
        <div className="flex flex-col items-end space-y-2">
          <div className="flex items-center space-x-2">
            {getStatusIcon()}
            <span className="text-sm font-medium">{getStatusText()}</span>
          </div>
          {lastUpdate && (
            <p className="text-xs text-gray-500">
              Last update: {lastUpdate.role} - {lastUpdate.timestamp}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}